/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightBetweenLines: {
  name: 'arrow-right-between-lines';
  data: string;
} = {
  name: 'arrow-right-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 4a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 4Zm12.146 1.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.793 8.5H1a.5.5 0 0 1 0-1h12.793l-1.147-1.146a.5.5 0 0 1 0-.708ZM1 11.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1Z" fill="currentColor"/></svg>`,
};
